import { Injectable } from '@angular/core';
import {BaseService} from './base.service';
import {HttpClient} from '@angular/common/http';
import {AlertService} from './alert.service';
import {GlobalService} from './global.service';
import {Observable} from 'rxjs';
import {AppUrl} from '../constants/app-url';

@Injectable({
  providedIn: 'root'
})
export class CategoryService extends BaseService {

  constructor(public http: HttpClient,
              public alertService: AlertService,
              public globalService: GlobalService) {
    super(http, alertService, globalService);
  }
  create(data): Observable<any> {
    return this.postRequest(AppUrl.CATEGORY(), data);
  }
  get(data): Observable<any> {
    return this.getRequest(AppUrl.CATEGORY(), data);
  }
  update(id, data): Observable<any> {
    return this.putRequest(AppUrl.CATEGORY(id), data);
  }
  detail(id): Observable<any> {
    return this.getRequest(AppUrl.CATEGORY(id));
  }
  updateStatus(id, data): Observable<any> {
    return this.putRequest(AppUrl.CATEGORY_STATUS(id), data);
  }

}
